import {
  type Brand,
  type CreateBrand,
  type CreateBrandForOrg201Response,
  type GetAllBrands200Response,
  type GetBrandsByOrgId200Response,
  BrandsApi,
  Configuration,
} from '@flipdish/orgmanagement';

import { getApiEndPoint } from '../../../helpers/apibase';
import { mapServerError } from '../../../services/utils/serverErrorMapper';

const baseURL = getApiEndPoint();

const configuration = new Configuration({
  basePath: baseURL,
  useDefaultUserAgent: true,
});

const defaultOptions = {
  withCredentials: true,
};

const brandsApi = new BrandsApi(configuration);

export const getBrandsForOrgKey = 'getBrandsForOrg';
export async function getBrandsForOrg(
  orgId: string
): Promise<{ data: GetBrandsByOrgId200Response }> {
  try {
    return await brandsApi.getBrandsByOrgId(orgId, defaultOptions);
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}

export const getBrandByIdKey = 'getBrandById';
export async function getBrandById({
  orgId,
  brandId,
}: {
  orgId: string;
  brandId: string;
}): Promise<{ data: CreateBrandForOrg201Response }> {
  try {
    return await brandsApi.getBrandById(orgId, brandId, defaultOptions);
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}

export const creaetBrandKey = 'createBrand';
export async function createBrand({
  orgId,
  brand,
  isSelfServe,
}: {
  orgId: string;
  brand: CreateBrand;
  isSelfServe?: string;
}): Promise<{ data: CreateBrandForOrg201Response }> {
  try {
    return await brandsApi.createBrandForOrg(orgId, brand, isSelfServe, defaultOptions);
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}

export const updateBrandKey = 'updateBrand';
export async function updateBrand({
  orgId,
  brand,
  brandId,
}: {
  orgId: string;
  brand: Brand;
  brandId: string;
}): Promise<{ data: CreateBrandForOrg201Response }> {
  try {
    return await brandsApi.updateBrandById(orgId, brandId, brand, defaultOptions);
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}

export const getAllBrandsKey = 'getAllBrands';
export async function getAllBrands({
  idOrNameContains,
  page,
  pageSize,
}: {
  idOrNameContains?: string;
  page?: number;
  pageSize?: number;
} = {}): Promise<{ data: GetAllBrands200Response }> {
  try {
    return await brandsApi.getAllBrands(idOrNameContains, page, pageSize, defaultOptions);
  } catch (e) {
    const err = await mapServerError(e);
    throw err;
  }
}

export const brandService = {
  createBrand,
  getBrandsForOrg,
  getBrandsForOrgKey,
  updateBrand,
  getBrandById,
  getAllBrands,
  getBrandByIdKey,
};

export default brandService;
